import { requestHandler } from "../lib/utils/network-client";

export function getProfessors(params = {}) {
  return requestHandler("/professors", {
    params
  });
}

export function createProfessor(payload) {
  return requestHandler("/professors", {
    method: "POST",
    body: payload
  });
}

export function updateProfessor(id, payload) {
  return requestHandler(`/professors/${id}`, {
    method: "PUT",
    body: payload
  });
}

export function deleteProfessor(id) {
  return requestHandler(`/professors/${id}`, {
    method: "DELETE"
  });
}
